import React from "react";
import PropTypes from "prop-types";
import { BULK_SUBSCRIPTION_USER_ROLES, BULK_SUBSCRIPTION_MAX_ADMIN_USERS } from "common/constants/v2/Constants";
import Modal, { MODAL_CLOSE_BUTTON_THEME } from "components/v3/modal/Modal";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import { BUTTON_THEME_WHITE } from "components/v3/primary-button/themes";
import styles from "./styles.module.scss";

class Menu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isRemoveUserModalOpen: false
        };

        this._onClickResendVerificationEmail = this._onClickResendVerificationEmail.bind(this);
        this._onConfirmRemoveUser = this._onConfirmRemoveUser.bind(this);
        this._toggleRemoveUserModal = this._toggleRemoveUserModal.bind(this);
        this._onClickAddAdmin = this._onClickAddAdmin.bind(this);
        this._onClickRemoveAdmin = this._onClickRemoveAdmin.bind(this);
    }

    _onClickAddAdmin(id) {
        const { addAdmin, closeMenu } = this.props;

        addAdmin(id);
        closeMenu();
    }

    _onClickRemoveAdmin(id) {
        const { removeAdmin, closeMenu } = this.props;

        removeAdmin(id);
        closeMenu();
    }

    _onClickResendVerificationEmail() {
        const { id, resendVerificationEmail, closeMenu } = this.props;

        resendVerificationEmail(id);
        closeMenu();
    }

    _onConfirmRemoveUser() {
        const { id, removeUser, closeMenu } = this.props;

        this._toggleRemoveUserModal(false);
        closeMenu();
        removeUser(id);
    }

    _toggleRemoveUserModal(isRemoveUserModalOpen) {
        this.setState({ isRemoveUserModalOpen });
    }

    render() {
        const { id, email, role, verified, numberOfAdmins } = this.props;
        const { isRemoveUserModalOpen } = this.state;

        return ( // eslint-disable-next-line
            <div className={ styles.menu } onClick={ (event) => event.stopPropagation() }>
                <ResendVerificationEmail verified={ verified } resendVerificationEmail={ this._onClickResendVerificationEmail } />
                <UpdateRole
                    id={ id }
                    verified={ verified }
                    role={ role }
                    numberOfAdmins={ numberOfAdmins }
                    addAdmin={ this._onClickAddAdmin }
                    removeAdmin={ this._onClickRemoveAdmin }
                />
                <RemoveUser
                    role={ role }
                    removeUser={ () => this._toggleRemoveUserModal(true) }
                />
                <RemoveUserModal
                    email={ email }
                    isOpen={ isRemoveUserModalOpen }
                    onCancel={ () => this._toggleRemoveUserModal(false) }
                    onConfirm={ this._onConfirmRemoveUser }
                />
            </div>
        );
    }
}

export const ResendVerificationEmail = ({ verified, resendVerificationEmail }) => {
    if (verified) {
        return null;
    }

    const className = `${ styles.menuOption } ${ styles.resendVerificationEmail }`;

    return (
        <button className={ className } type="button" onClick={ resendVerificationEmail }>
            Resend verification email
        </button>
    );
};

export const RemoveUser = ({ role, removeUser }) => {
    if (role === BULK_SUBSCRIPTION_USER_ROLES.ADMIN) {
        return null;
    }

    const className = `${ styles.menuOption } ${ styles.removeUser }`;

    return (
        <button className={ className } type="button" onClick={ removeUser }>
            Remove user
        </button>
    );
};

const UpdateRole = ({ id, verified, role, numberOfAdmins, addAdmin, removeAdmin }) => {
    if (!verified) {
        return null;
    }

    switch (role) {
        case BULK_SUBSCRIPTION_USER_ROLES.ADMIN:
            return <RemoveAdmin id={ id } removeAdmin={ removeAdmin } />;
        case BULK_SUBSCRIPTION_USER_ROLES.USER:
            return <MakeAdmin id={ id } addAdmin={ addAdmin } numberOfAdmins={ numberOfAdmins } />;
        default:
            return null;
    }
};

export const MakeAdmin = ({ id, addAdmin, numberOfAdmins }) => {
    if (numberOfAdmins >= BULK_SUBSCRIPTION_MAX_ADMIN_USERS) {
        return null;
    }

    return (
        <button className={ styles.menuOption } type="button" onClick={ () => addAdmin(id) }>
            Assign customer admin
        </button>
    );
};

export const RemoveAdmin = ({ id, removeAdmin }) => {
    return (
        <button className={ styles.menuOption } type="button" onClick={ () => removeAdmin(id) }>
            Remove customer admin
        </button>
    );
};

export const RemoveUserModal = ({ email, isOpen, onCancel, onConfirm }) => {
    return (
        <Modal
            isInformational={ false }
            closeButtonTheme={ MODAL_CLOSE_BUTTON_THEME.SMALL }
            isOpen={ isOpen }
            onClose={ onCancel }
        >
            <div className={ styles.removeModalHeader }>
                Remove user
            </div>
            <div className={ styles.removeModalText }>
                Are you sure you want to remove the email:
                <br />
                <span className={ styles.removeModalEmail }>{ email }</span>
                <br />
                <br />
                This action cannot be undone.
            </div>
            <div className={ styles.removeModalButtons }>
                <div className={ styles.removeModalButton }>
                    <PrimaryButton text="Yes" onClick={ onConfirm } />
                </div>
                <div className={ styles.removeModalButton }>
                    <PrimaryButton text="Cancel" theme={ BUTTON_THEME_WHITE } onClick={ onCancel } />
                </div>
            </div>
        </Modal>
    );
};

Menu.propTypes = {
    id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    verified: PropTypes.bool,
    numberOfAdmins: PropTypes.number.isRequired,
    closeMenu: PropTypes.func.isRequired,
    addAdmin: PropTypes.func.isRequired,
    removeAdmin: PropTypes.func.isRequired,
    resendVerificationEmail: PropTypes.func.isRequired,
    removeUser: PropTypes.func.isRequired
};

export default Menu;
